var map = {
	"./culik/checksurat-min.png": "c5b6",
	"./menanga/checksurat-min.png": "5337",
	"./remun-surat/checksurat-min.png": "308c",
	"./sangsit/checksurat-min.png": "3f85",
	"./sibetan/checksurat-min.png": "59c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7f4";